import Account from "@/helper/AccountHelper.js";

const IS_REGISTER = 1;  // 0001
const BRONZE = 2;       // 0010
const SILVER = 4;       // 0100
const GOLD = 8;         // 1000
const PLATINUM = 16;    // 10000

export function UserLevel() {
    this.userLevel = Account.getUserLevel();

    this.isRegistered = function () {
        let rs = this.userLevel & IS_REGISTER;
        return rs != 0 || this.userLevel > 0;
    };

    this.isBronze = function () {
        let rs = this.userLevel & BRONZE;
        return rs != 0;
    };

    this.isSilver = function () {
        let rs = this.userLevel & SILVER;
        return rs != 0;
    };

    this.isGold = function () {
        let rs = this.userLevel & GOLD;
        return rs != 0;
    };

    this.isPlatinum = function () {
        let rs = this.userLevel & PLATINUM;
        return rs != 0;
    };
}
